import Vue from 'vue';
import Router from 'vue-router';
import userStore from './store/userStore';

Vue.use(Router);

function requireAuth(to, from, next) {
  if (!userStore.user.email) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    });
  } else {
    next();
  }
}

export default new Router({
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '*',
      redirect: '/calculator',
    },
    {
      path: '/callback',
      name: 'callback',
      component: () => import(/* webpackChunkName: "callback" */ './views/Callback.vue'),
    },
    {
      path: '/login',
      name: 'home',
      component: () => import(/* webpackChunkName: "user-login" */ './views/Login.vue'),
    },
    {
      path: '/calculator',
      name: 'calculator',
      beforeEnter: requireAuth,
      redirect: {
        name: 'createProject',
      },
      component: () => import(/* webpackChunkName: "pricing" */ './views/Pricing.vue'),
      children: [
        {
          path: 'create',
          name: 'createProject',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "pricing" */ './views/pricing/createProject.vue'),
        },
        {
          path: 'offer',
          name: 'customerOffer',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "pricing" */ './views/pricing/customerOffer.vue'),
        },
        {
          path: 'wage',
          name: 'wageCalculator',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "pricing" */ './views/pricing/hourlyWage.vue'),
        },
        {
          path: 'materials',
          name: 'addedMaterials',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "pricing" */ './views/pricing/addedMaterials.vue'),
        },
        {
          path: 'summary',
          name: 'internalCostsSummary',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "pricing" */ './views/pricing/internalCostsSummary.vue'),
        },
      ],
    },
    {
      path: '/discounts',
      name: 'discounts',
      beforeEnter: requireAuth,
      component: () => import(/* webpackChunkName: "discounts" */ './views/UserDiscounts.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      beforeEnter: requireAuth,
      redirect: {
        name: 'adminDashboard',
      },
      component: () => import(/* webpackChunkName: "group-settings" */ './views/Settings.vue'),
      children: [
        {
          path: 'dashboard',
          name: 'adminDashboard',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "group-settings" */ './views/settings/dashboard.vue'),
        },
        {
          path: 'company',
          name: 'companyManagement',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "group-settings" */ './views/settings/companyManagement.vue'),
        },
        {
          path: 'users',
          name: 'userManagement',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "group-settings" */ './views/settings/userManagement.vue'),
        },
        {
          path: 'productlist',
          name: 'productList',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "group-settings" */ './views/settings/ProductList.vue'),
        },
        {
          path: 'roofmodel',
          name: 'roofModelManagement',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "group-settings" */ './views/settings/roofModel.vue'),
        },
        {
          path: 'roofmodel/:id',
          name: 'updateRoofModel',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "group-settings" */ './views/settings/updateRoofModel.vue'),
        },
        {
          path: 'components',
          name: 'componentsManagement',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "group-settings" */ './views/settings/componentsManagement.vue'),
        },
        {
          path: 'components/:id',
          name: 'updateComponent',
          beforeEnter: requireAuth,
          component: () => import(/* webpackChunkName: "group-settings" */ './views/settings/updateComponent.vue'),
        },
      ],
    },
  ],
});
